<template>
    <button @click.prevent="$emit('preview-button-clicked')" type="submit"
            class="inline-flex justify-center py-2 px-4 border border-transparent
                                            text-sm leading-5 font-medium rounded-md text-white focus:outline-none
                                            focus:border-indigo-700 focus:ring-indigo transition
                                            duration-150 ease-in-out"
            :class="isValid ? 'bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-700' : 'bg-gray-300 bg-gray-200'"
    >{{ text }}
    </button>
</template>

<script>
    export default {
        name: "FormPreviewButton",
        props: {
            text: String,
            isValid: Boolean
        }
    }
</script>
